const {mobileBreakpoint} = require("app/settings");

class Screen {

	get width() {
		return window.innerWidth;
	}

	get height() {
		return window.innerHeight;
	}

	mobile() {
		return this.width <= mobileBreakpoint;
	}

	desktop() {
		return this.width > mobileBreakpoint;
	}

}

module.exports = new Screen();